var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnmuteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.074 1.61435C13.6345 1.84652 14 2.39347 14 3.00017V21.0002C14 21.6069 13.6345 22.1538 13.074 22.386C12.5135 22.6182 11.8683 22.4898 11.4393 22.0608L5.87868 16.5002H2C1.17157 16.5002 0.5 15.8286 0.5 15.0002V9.00017C0.5 8.17174 1.17157 7.50017 2 7.50017H5.87868L11.4393 1.93951C11.8683 1.51051 12.5135 1.38218 13.074 1.61435Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9853 1.39344C21.5711 0.807655 22.5208 0.807655 23.1066 1.39344C25.8194 4.10627 27.5 7.85832 27.5 12C27.5 16.1418 25.8194 19.8938 23.1066 22.6066C22.5208 23.1924 21.5711 23.1924 20.9853 22.6066C20.3995 22.0209 20.3995 21.0711 20.9853 20.4853C23.1585 18.3121 24.5 15.3142 24.5 12C24.5 8.68592 23.1585 5.68798 20.9853 3.51476C20.3995 2.92898 20.3995 1.97923 20.9853 1.39344ZM16.7426 5.63608C17.3284 5.0503 18.2782 5.0503 18.8639 5.63608C19.6528 6.4249 20.2965 7.36043 20.7504 8.39949C21.233 9.504 21.5 10.7228 21.5 12C21.5 14.4849 20.491 16.737 18.8639 18.364C18.2782 18.9498 17.3284 18.9498 16.7426 18.364C16.1568 17.7782 16.1568 16.8285 16.7426 16.2427C17.8301 15.1553 18.5 13.6573 18.5 12C18.5 11.144 18.3216 10.3335 18.0014 9.6006C17.6994 8.90949 17.2702 8.28503 16.7426 7.7574C16.1568 7.17162 16.1568 6.22187 16.7426 5.63608Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnmuteIcon);
export default __webpack_public_path__ + "static/media/UnmuteIcon.b95a7e81f5d30836934cc11cfbb4b656.svg";
export { ForwardRef as ReactComponent };